import React, { useState, useEffect } from "react";
import { IProducts, IProductsList } from "../../../products/dto/IProducts";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { PageTemplate } from "../../../../shared/layout/PageTemplate";
import { ProductsService } from "../../../products/service";
import { ErrorToast } from "../../../../shared/toasters/toasters";
import { BaseDataView } from "../../../products/baseData/components/BaseDataView";

export const BaseDataViewAction = () => {
  const [currentProduct, setCurrentProduct] = useState<IProducts>();
  const { id } = useParams();
  const { t } = useTranslation();
  useEffect(() => {
    id &&
      ProductsService.getViewProductsById(+id)
        .then((response) => {
          setCurrentProduct(response);
        })
        .catch((error) => ErrorToast(error));
  }, [id]);
  return (
    <>
      <div className="col-md-12">
        <div className="page-title-box d-sm-flex align-items-center justify-content-between ">
          <div className="d-flex align-itmes-end">
            <ul className="nav nav-pills nav-fill">
              <li className="nav-item">
                <span className="nav-link active">
                  {t("products.base_data_view")}
                </span>
              </li>
              <li>
                <Link
                  className="nav-link"
                  to={`/app/products/view/attributes/${id}`}
                >
                  {t("products.attributes_view")}
                </Link>
              </li>
              <li>
                <Link
                  className="nav-link"
                  to={`/app/products/view/content/${id}`}
                >
                  {t("products.content_view")}
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="col-md-12 mb-3 d-flex align-items-center justify-content-between">
        <div>
          <h2>{currentProduct?.title}</h2>
        </div>
      </div>
      <BaseDataView currentProduct={currentProduct as IProductsList} />
    </>
  );
};
